module.exports = __webpack_public_path__ + "static/media/IMG_3858 (3)_1631186378313.208a7967.PNG";